export const CLOTHING_CATEGORIES = [
  "Custom Hoodies",
  "Custom T-Shirts",
  "Custom Racerbacks",
] as const;

export const CUSTOM_CLOTHING_CATEGORIES = [
  "Custom Hoodies",
  "Custom T-Shirts",
  "Custom Racerbacks",
] as const;

export type ClothingCategory = (typeof CLOTHING_CATEGORIES)[number];
export type CustomClothingCategory =
  (typeof CUSTOM_CLOTHING_CATEGORIES)[number];

const CLOTHING_CATEGORY_MAP = {
  "Custom Hoodies": "Custom Hoodies",
  "Custom T-Shirts": "Custom T-Shirts",
  "Custom Racerbacks": "Custom Racerbacks",
} as const;

export const isClothingCategory = (
  category: string
): category is ClothingCategory => {
  return (CLOTHING_CATEGORIES as readonly string[]).includes(category);
};

export const isCustomClothingCategory = (
  category: string
): category is CustomClothingCategory => {
  return (CUSTOM_CLOTHING_CATEGORIES as readonly string[]).includes(category);
};

export const getCustomCategory = (
  category: string
): CustomClothingCategory | null => {
  const customCategory = Object.entries(CLOTHING_CATEGORY_MAP).find(
    ([key]) => key === category
  )?.[1];
  return customCategory || null;
};
